/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchMatrixCareHomeHealthPatientsResponse } from './SearchMatrixCareHomeHealthPatientsResponse';
import {
    SearchMatrixCareHomeHealthPatientsResponseFromJSON,
    SearchMatrixCareHomeHealthPatientsResponseFromJSONTyped,
    SearchMatrixCareHomeHealthPatientsResponseToJSON,
    SearchMatrixCareHomeHealthPatientsResponseToJSONTyped,
} from './SearchMatrixCareHomeHealthPatientsResponse';

/**
 * 
 * @export
 * @interface SearchMatrixCareHomeHealthPatients200Response
 */
export interface SearchMatrixCareHomeHealthPatients200Response {
    /**
     * 
     */
    data?: SearchMatrixCareHomeHealthPatientsResponse;
}

/**
 * Check if a given object implements the SearchMatrixCareHomeHealthPatients200Response interface.
 */
export function instanceOfSearchMatrixCareHomeHealthPatients200Response(value: object): value is SearchMatrixCareHomeHealthPatients200Response {
    return true;
}

export function SearchMatrixCareHomeHealthPatients200ResponseFromJSON(json: any): SearchMatrixCareHomeHealthPatients200Response {
    return SearchMatrixCareHomeHealthPatients200ResponseFromJSONTyped(json, false);
}

export function SearchMatrixCareHomeHealthPatients200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchMatrixCareHomeHealthPatients200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : SearchMatrixCareHomeHealthPatientsResponseFromJSON(json['data']),
    };
}

export function SearchMatrixCareHomeHealthPatients200ResponseToJSON(json: any): SearchMatrixCareHomeHealthPatients200Response {
    return SearchMatrixCareHomeHealthPatients200ResponseToJSONTyped(json, false);
}

export function SearchMatrixCareHomeHealthPatients200ResponseToJSONTyped(value?: SearchMatrixCareHomeHealthPatients200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': SearchMatrixCareHomeHealthPatientsResponseToJSON(value['data']),
    };
}

